import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { createSitInOutbound, createSitOutOutbound } from '../../../api/outbound/pokerOutbounds';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../../redux/store';
export const SitInOrOutButtonContainer = ({ onButtonClicked }) => {
    const socketSend = useSocketSend();
    const mySeatIndex = useAppSelector((state) => state.poker.mySeatIndex);
    const isSittingOut = useAppSelector((state) => state.poker.isSelfSittingOut);
    const isSitting = mySeatIndex !== undefined;
    const onClickSitOut = useCallback(() => {
        socketSend(createSitOutOutbound());
        onButtonClicked();
    }, [onButtonClicked, socketSend]);
    const onClickSitIn = useCallback(() => {
        socketSend(createSitInOutbound());
        onButtonClicked();
    }, [onButtonClicked, socketSend]);
    if (!isSitting) {
        return null;
    }
    return isSittingOut ? (_jsx(Button, { variant: 'contained', onClick: onClickSitIn, size: 'large', fullWidth: true, children: "Sit In" })) : (_jsx(Button, { variant: 'outlined', onClick: onClickSitOut, size: 'small', fullWidth: true, children: "Sit Out" }));
};
